export default [
  {
    path: '/form-register',
    name: 'form-screening',
    component: () => import('@/views/coste-screening/screening.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/screening-update/:id',
    name: 'screening-update',
    component: () => import('@/views/coste-screening/screening-update.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/screening/list',
    name: 'apps-screening-list',
    component: () => import('@/views/coste-screening/screening-list.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/orders',
    name: 'legal-orders',
    component: () => import('@/views/coste-screening/orders.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/Event-Base',
    name: 'event-base',
    component: () => import('@/views/coste-screening/event-base/view.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/kiosk',
    name: 'kiosk-screening',
    component: () => import('@/views/coste-screening/kiosk.vue'),
    meta: {
      layout: 'full',
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/kiosk-panel',
    name: 'kiosk-panel',
    component: () => import('@/views/coste-screening/kiosk.vue'),
    meta: {
      layout: 'full',
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/Vehicle/screening',
    name: 'vehicle-screening',
    component: () => import('@/views/coste-screening/vehicle/vehicle-screening.vue'),
    meta: {
      resource: 'UserLand',
      action: 'read',
    },
  },
  {
    path: '/Vehicle/screening-update/:id',
    name: 'vehicle-update',
    component: () => import('@/views/coste-screening/vehicle/vehicle-update.vue'),
    meta: {
      resource: 'UserLand',
      action: 'read',
    },
  },
  {
    path: '/Vehicle/list',
    name: 'vehicle-list',
    component: () => import('@/views/coste-screening/vehicle/vehicle-list.vue'),
    meta: {
      resource: 'LandList',
      action: 'read',
    },
  },
  {
    path: '/Vehicle/waiting-list',
    name: 'vehicle-waiting-list',
    component: () => import('@/views/coste-screening/vehicle/vehicle-waiting-list.vue'),
    meta: {
      resource: 'UserLand',
      action: 'read',
    },
  },
  {
    path: '/Vehicle/waiting-list/add',
    name: 'vehicle-waiting-list-add',
    component: () => import('@/views/coste-screening/vehicle/vehicle-waiting-list-add.vue'),
    meta: {
      resource: 'UserLand',
      action: 'read',
    },
  },
  {
    path: '/Covid-19/Detected',
    name: 'covid-19-detected',
    component: () => import('@/views/coste-screening/covid19/view.vue'),
    meta: {
      resource: 'UserLand',
      action: 'read',
    },
  },
  {
    path: '/users-management',
    name: 'users-management',
    component: () => import('@/views/coste-screening/users-list.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/airport-management',
    name: 'airport-management',
    component: () => import('@/views/coste-screening/airport-list.vue'),
    meta: {
      resource: 'BigAdmin',
      action: 'read',
    },
  },
  {
    path: '/odpc-management',
    name: 'odpc-management',
    component: () => import('@/views/coste-screening/odpc-list.vue'),
    meta: {
      resource: 'BigAdmin',
      action: 'read',
    },
  },
  {
    path: '/log-login',
    name: 'log-login',
    component: () => import('@/views/coste-screening/log-login.vue'),
    meta: {
      resource: 'BigAdmin',
      action: 'read',
    },
  },
  {
    path: '/audit-log',
    name: 'audit-log',
    component: () => import('@/views/coste-screening/audit-log.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/api-logs',
    name: 'api-logs',
    component: () => import('@/views/coste-screening/api-logs.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/gate-list',
    name: 'gate-list',
    component: () => import('@/views/coste-screening/gate-list.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/gate-verify',
    name: 'gate-verify',
    component: () => import('@/views/coste-screening/gate-verify.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/kiosk-list',
    name: 'kiosk-list',
    component: () => import('@/views/coste-screening/kiosk-list.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/box-list',
    name: 'amy-box-list',
    component: () => import('@/views/coste-screening/amy-box/box-list.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/box-monitoring',
    name: 'amy-box-monitoring',
    component: () => import('@/views/coste-screening/amy-box/box-monitoring.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/face-detection',
    name: 'face-detection',
    component: () => import('@/views/coste-screening/face-detection.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/face-detection-alert/:id',
    name: 'face-detection-alert',
    component: () => import('@/views/coste-screening/face-detection-alert.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/airport-management/add/:id?',
    name: 'airport-management-add',
    component: () => import('@/views/coste-screening/airport-management.vue'),
    meta: {
      resource: 'BigAdmin',
      action: 'read',
    },
  },
  {
    path: '/odpc-management/add/:id?',
    name: 'odpc-management-add',
    component: () => import('@/views/coste-screening/odpc-management.vue'),
    meta: {
      resource: 'BigAdmin',
      action: 'read',
    },
  },
  {
    path: '/dashborad',
    name: 'screen-dashboard',
    component: () => import('@/views/coste-screening/dashboard/dashboard.vue'),
    meta: {
      resource: 'Air',
      action: 'read',
    },
  },
  {
    path: '/dashborad-new',
    name: 'screen-dashboard-new',
    component: () => import('@/views/coste-screening/dashboard-new/dashboard.vue'),
    meta: {
      resource: 'Land',
      action: 'read',
    },
  },
  {
    path: '/coe',
    name: 'screen-coe',
    component: () => import('@/views/coste-screening/coe.vue'),
    meta: {
      resource: 'Admin',
      action: 'read',
    },
  },
  {
    path: '/thpass',
    name: 'thpass',
    component: () => import('@/views/coste-screening/thpass.vue'),
    meta: {
      resource: 'Admin',
      action: 'read',
    },
  },
  {
    path: '/ddc-pass',
    name: 'ddcpass',
    component: () => import('@/views/coste-screening/ddcpass.vue'),
    meta: {
      resource: 'Admin',
      action: 'read',
    },
  },
  {
    path: '/users-management/add/:id?',
    name: 'users-management-add',
    component: () => import('@/views/coste-screening/users-management.vue'),
    meta: {
      resource: 'AdminManage',
      action: 'read',
    },
  },
  {
    path: '/screening/edit/:id',
    name: 'apps-screening-edit',
    component: () => import('@/views/coste-screening/screening-management.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/import-excel',
    name: 'import-excel',
    component: () => import('@/views/coste-screening/ImportExcel.vue'),
    meta: {
      resource: 'BigAdmin',
      action: 'read',
    },
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('@/views/coste-screening/welcome.vue'),
    meta: {
      layout: 'full',
      resource: 'User',
      action: 'read',
    },
  },
  {
    path: '/edit-profile/:id',
    name: 'edit-profile',
    component: () => import('@/views/coste-screening/DDC/edit.vue'),
    meta: {
      resource: 'User',
      action: 'read',
    },
  },
]
